<template>
  <div class="navigation-view-selector">
    <div
      v-for="(item, index) in getOptions"
      :key="'navigationTypeView' + index"
      class="navigation-view-selector__option"
      :class="[{ active: evalViewType(item.id) }]"
      @click="$emit('on-select-view', item.id)"
    >
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavigationTypeView',
  props: {
    viewType: {
      type: Number,
      default: () => 1,
    },
  },
  computed: {
    evalViewType() {
      return (id) => id === this.viewType;
    },
    getOptions() {
      return [
        { id: 1, name: 'Mes' },
        { id: 2, name: 'Semana' },
        { id: 3, name: 'Día' },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.navigation-view-selector {
  display: flex;
  cursor: pointer;
  &__option {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #3f5b60;
    width: 105px;
    height: 38px;
    span {
      user-select: none;
    }
    &.active {
      border-radius: 8px;
      background: #ff7058;
      color: #fff;
    }
  }
}
</style>
